import { Routes } from '@angular/router';
import { OrderCompleteResolver } from './home/resolvers/order-complete.resolver';
import { SquareCatalogResolver } from './home/resolvers/square-catalog.resolver';
import { EventProtectionResolver } from './home/resolvers/event-protection.resolver';
import { EventProtectionGuard } from './services/event-protection.guard';
import { TimeoutComponent } from './home/timeout/timeout.component';

export const routes: Routes = [
  {
    path: 'order/:id',
    async loadComponent() {
      const m = await import('./home/square-catalog/square-catalog.component');
      return m.SquareCatalogComponent;
    },
    resolve: { SquareCatalogResponse: SquareCatalogResolver },
  },
  {
    path: 'store/:id',
    async loadComponent() {
      const m = await import('./home/square-catalog/square-catalog.component');
      return m.SquareCatalogComponent;
    },
    resolve: { SquareCatalogResponse: SquareCatalogResolver },
  },
  {
    path: 'organizer-square-giftcard/:appId/:orderTotal',
    async loadComponent() {
      const m = await import('./home/organizer-square-giftcard/organizer-square-giftcard.component');
      return m.OrganizerSquareGiftcardComponent;
    },
  },
  {
    path: 'password-domain-privacy',
    async loadComponent() {
      const m = await import('./home/password-domain-privacy/password-domain-privacy.component');
      return m.PasswordDomainPrivacyComponent;
    },
    resolve: { EventProtectionOverRideResponse: EventProtectionResolver },
  },
  {
    path: 'order-center/:appId/:orderIdentifier',
    async loadComponent() {
      const m = await import('./home/order-center/order-center.component');
      return m.OrderCenterComponent;
    },
  },
  {
    path: 'order-center/:appId',
    async loadComponent() {
      const m = await import('./home/order-center/order-center.component');
      return m.OrderCenterComponent;
    },
  },
  {
    path: 'order-center',
    async loadComponent() {
      const m = await import('./home/order-center/order-center.component');
      return m.OrderCenterComponent;
    },
  },
  {
    path: '',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
    canActivate: [EventProtectionGuard],
  },
  {
    path: ':appId/:id',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
    canActivate: [EventProtectionGuard],
  },
  {
    path: 'm/:appId/:id',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
  },
  {
    path: 's/:appId/:id',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
  },
  {
    path: 'c/:appId/:id',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
  },
  {
    path: 'w/:appId/:id',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
  },
  {
    path: 'f/:appId/:id',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
  },
  {
    path: 'multi-event/:appId/:id',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
  },
  // For FlexPass Week Day ticket Convert to Weekend Day
  {
    path: 'switch-time/:app-id/:barcode-id/:order-id/:user-id',
    async loadComponent() {
      const m = await import('./home/switch-ticket/switch-ticket.component');
      return m.SwitchTicketComponent;
    },
  },
  {
    path: 'square-products/:appId/:id',
    async loadComponent() {
      const m = await import('./home/home.component');
      return m.HomeComponent;
    },
  },
  {
    path: 'ordercomplete',
    async loadComponent() {
      const m = await import('./home/order-complete/order-complete.component');
      return m.OrderCompleteComponent;
    },
    resolve: {
      orderCompleteData: OrderCompleteResolver,
    },
  },
  {
    path: 'signup',
    async loadComponent() {
      const m = await import('./home/signup/signup.component');
      return m.SignupComponent;
    },
  },
  {
    path: 'timeout',
    // Not lazy (MP-5600): the timeout page releases the expired cart using ids held only in memory, so it must not
    // depend on a chunk that can fail to load after a deploy.
    component: TimeoutComponent,
  },
  {
    path: 'checkout/:appId/:id/:orderId',
    async loadComponent() {
      const m = await import('./home/checkout/checkout.component');
      return m.CheckoutComponent;
    },
  },
  {
    path: 'questions/:appId/:id',
    async loadComponent() {
      const m = await import('./home/attendee-questions/attendee-questions.component');
      return m.AttendeeQuestionsComponent;
    },
  },
  {
    path: 'membership-questions/:appId/:id',
    async loadComponent() {
      const m = await import('./home/membership-attendee-questions/membership-attendee-questions.component');
      return m.MembershipAttendeeQuestionsComponent;
    },
  },
  {
    path: 'attendee-document/:appId/:orderIdentifier',
    async loadComponent() {
      const m = await import('./home/upload-doc/upload-doc.component');
      return m.UploadDocComponent;
    },
  },
  {
    path: 'edit-card-detail/:appId/:id',
    async loadComponent() {
      const m = await import('./home/edit-payment-detail/edit-payment-detail.component');
      return m.EditPaymentDetailComponent;
    },
  },
  {
    path: 'exchange/pay/:appId/:token',
    async loadComponent() {
      const m = await import('./home/exchange-payment-link/exchange-payment-link.component');
      return m.ExchangePaymentLinkComponent;
    },
  },
  {
    path: 'error-page',
    async loadComponent() {
      const m = await import('./snippets/error-message/error-message.component');
      return m.ErrorMessageComponent;
    },
  },
  {
    path: '404',
    async loadComponent() {
      const m = await import('./snippets/error-page/error-page.component');
      return m.ErrorPageComponent;
    },
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
  },
];
